export default {"src":"/_next/static/media/exp-icon.0d064581.svg","height":34,"width":26};